<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Copy Role Permissions</h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body">
      <div>
        <mat-form-field *ngIf="isSuperAdmin" appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="ROLES.FORM.COMPANY">Company</mat-label>
          <mat-select [(ngModel)]="role" (selectionChange)="selectCompany($event)">
            <mat-option *ngFor="let company of companiesList" [value]="company.id">
              {{ company.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <kt-general-autocomplete
          [appearance]="'fill'"
          [label]="'Role'"
          [loadItemsFunction]="searchRolesFn"
          [optionFormatter]="filterRoleFn"
          [valueFormatter]="filterRoleFn"
          [required]="true"
          [readOnly]="disableBtns"
          [control]="roleCtrl"
          [change]="selected.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Roles'"
          [objects]="roleCtrl.value"
          [formatNewObjectFn]="formatNewRoleFn"
          #roleAutocomplete
        ></kt-general-autocomplete>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="false"
            cdkFocusInitial
            [disabled]="disableBtns"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            [disabled]="disableBtns"
            color="primary"
            (click)="onSubmit()"
          >
            <span>Select</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
